/**
 * Eyebrow primitive — design.md § Typography: eyebrow.
 *
 * Renders monospace uppercase label per design.md typography.eyebrow.
 * 6px accent dot indicator via inline <span> element.
 * font-mono, text-eyebrow, uppercase, tracking-wide.
 */
import type { HTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface EyebrowProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export const Eyebrow = forwardRef<HTMLSpanElement, EyebrowProps>(
  function Eyebrow(
    {
      className,
      children,
      ...props
    },
    ref,
  ) {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center gap-2',
          'font-mono text-eyebrow font-medium uppercase tracking-wide',
          'text-muted',
          className,
        )}
        {...props}
      >
        <span
          data-eyebrow-dot
          className="inline-block h-1.5 w-1.5 rounded-pill bg-accent"
          aria-hidden="true"
        />
        {children}
      </span>
    );
  },
);
